import { createFileRoute } from "@tanstack/react-router";
import { OFFICIAL_APP_URL } from "@/lib/app-url";
import { AuthScreen } from "@/components/auth-screen";

export const Route = createFileRoute("/")({
  head: () => ({
    meta: [
      { title: "Entrar · Beit Tefilah Rechovot" },
      {
        name: "description",
        content: "Acesse a área de membros da congregação Beit Tefilah Rechovot.",
      },
      {
        name: "keywords",
        content:
          "Beit Tefilah Rechovot, ensinos judaicos, Parashá, Torá, Casa de Oração, Shabat, área de membros",
      },
      { property: "og:url", content: `${OFFICIAL_APP_URL}/` },
      { property: "og:type", content: "website" },
      { property: "og:title", content: "Entrar · Área de Ensinos Beit Tefilah Rechovot" },
      {
        property: "og:description",
        content:
          "Login exclusivo para membros: acesse o acervo de ensinos por Parashá, data e festividade.",
      },
      { name: "robots", content: "noindex" },
    ],
    links: [{ rel: "canonical", href: `${OFFICIAL_APP_URL}/` }],
  }),
  // A raiz mostra o próprio login (sem redirecionar), evitando um salto extra
  // na primeira visita. Membros autenticados seguem para /inicio.
  component: AuthScreen,
});
